export const ProductModel = {
    name: "",
    description: "",
    price: undefined,
    image: "",
    sellerId: "",
   
};